<template>
    <div class="pagination" v-if="totalRecords > 0">
        <p class="m-0" v-if="showRecords">
            {{$t('total_records') }} <span class="totalRecords">{{totalRecords}}</span>
        </p> 
        <paginate
            :page-count="Math.ceil(totalRecords/limit)"
            :page-range="3"
            :click-handler="fetchData"
            :prev-text="'Prev'"
            :next-text="'Next'" 
            :container-class="'pagination'"
            :hide-prev-next="false"
            :force-page="parseInt(pageNo)">
        </paginate>
    </div>
</template>
<script>
    export default {
        name: 'PAGINATION',
        data () {
            return { }
        },
        props:['totalRecords','limit','pageNo','showRecords'],
        methods:{
            fetchData(pageNum){
                this.$parent.page = pageNum
                try { 
                    this.$parent.listing() 
                } catch (e) {}
                
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/shared/pagination.vue